import {
  type ICustomMappingSourceOption,
  type IPracticeMigration,
} from '@principle-theorem/practice-migrations/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { sortBy } from 'lodash';
import {
  FeeScheduleMappingHandler,
  IBaseMigrationFeeSchedule,
} from '../../../mappings/fee-schedules';
import {
  FeeScheduleSourceEntity,
  IPraktikaFeeSchedule,
  PraktikaFeeSchedule,
} from '../../source/entities/fee-schedule';

export class PraktikaFeeScheduleMappingHandler extends FeeScheduleMappingHandler<
  PraktikaFeeSchedule,
  FeeScheduleSourceEntity
> {
  override sourceEntity = new FeeScheduleSourceEntity();
  translateFn = (record: IPraktikaFeeSchedule): IBaseMigrationFeeSchedule => ({
    ...record,
  });

  override async getSourceOptions(
    migration: WithRef<IPracticeMigration>
  ): Promise<ICustomMappingSourceOption[]> {
    const entity = new FeeScheduleSourceEntity();
    const records = await entity.getAllRecords$(migration).toPromise();
    const options = records.map(({ data }) => ({
      label: `${data.name} ${data.practice_id ?? ''}`,
      value: entity.getSourceRecordId(data).toString(),
    }));

    return sortBy(options, 'label');
  }
}
